import { Button, useDisclosure } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { CoverageReviewModal } from '../UnitsOfCompetency/UnitGeneration/components/CoverageReviewModal';

export function ContinueGenerationButton({ unitId }: { unitId: string }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { data: run } = trpcAdmin.unitsOfCompetency.continuableGenerationByUnitId.useQuery({
    unitId,
  });

  if (run == null) {
    return null;
  }

  return (
    <>
      <Button variant="primary" size="sm" onClick={onOpen}>
        {run.isRetry ? <Trans>Retry content generation</Trans> : <Trans>Continue generation</Trans>}
      </Button>

      {isOpen ? (
        <CoverageReviewModal runId={run.id} isRetry={run.isRetry} onClose={onClose} />
      ) : null}
    </>
  );
}
